export const PHONE_REGEXP = new RegExp(/^[1][2,3,4,5,67,8,9][0-9]{9}$/);


// WEBPACK FOOTER //
// ./src/util/regExp.js